import React, { useState } from "react";
import { Layout, Card, Alert } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import HeaderComponent from "../../components/HeaderComponent";
import SidebarComponent from "../../components/sidebarComponent";

const NetworkCenterProfile = () => {
    const [isSidebarOpen, setSidebarOpen] = useState(true);

    const toggleSidebar = () => {
        setSidebarOpen(!isSidebarOpen);
    };

    const url =
        "https://flux.getvisitapp.com/app/network-center-profile/0nht1tsdqu";

    return (
        <Layout style={{ minHeight: "100vh" }}>
            {/* Header */}
            <HeaderComponent />

            <div style={{ display: "flex" }}>
                {/* Sidebar */}
                <div style={{ zIndex: 1000 }}>
                    <SidebarComponent
                        isSidebarOpen={isSidebarOpen}
                        toggleSidebar={toggleSidebar}
                    />
                </div>

                {/* Content Area */}
                <div
                    style={{
                        flex: 1,
                        padding: "0px",
                        backgroundColor: "#f0f2f5",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Card
                        title={
                            <span
                                style={{
                                    fontWeight: "bold",
                                    fontSize: "22px",
                                }}
                            >
                                Centers
                            </span>
                        }
                        bordered={true}
                        headStyle={{ borderBottom: "none", paddingLeft: "16px" }} // ensures title aligns with content
                        style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "0px",
                        }}
                        bodyStyle={{ padding: 0, height: "100%" }}
                    >
                        {/* Alert below the title aligned with title */}
                        <div style={{ padding: "0 16px 8px 16px" }}>
                            <Alert
                                type="warning"
                                showIcon={false}
                                message={
                                    <div>
                                        <div className="flex items-center gap-3" style={{ "marginBottom": "4px" }}>
                                            <ExclamationCircleOutlined style={{ color: '#FF8C00', fontSize: '18px' }} />
                                            <span style={{ "paddingLeft": "5px" }}>This feature includes all pre-payment centers that are not linked to a Cortis Billing Entity.</span>
                                        </div>
                                        <div className="flex items-center gap-3 mt-2">
                                            <ExclamationCircleOutlined style={{ color: '#FF8C00', fontSize: '18px' }} />
                                            <span style={{ "paddingLeft": "5px" }}>By default, the date range is set from 2024-01-01 00:00:01 to the current date and time.</span>
                                        </div>
                                    </div>
                                }
                            />


                        </div>

                        <iframe
                            src={url}
                            title="Flux Network Center Profile"
                            style={{
                                width: "100%",
                                height: "calc(100% - 52px)", // adjusted for alert height
                                border: "0",
                                borderRadius: "0 0 12px 12px",
                            }}
                        />
                    </Card>
                </div>
            </div>
        </Layout>
    );
};

export default NetworkCenterProfile;
